
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-close\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10s10-4.477,10-10S15.523,0,10,0 M15.86,14.046\r\n\tc0.167,0.167,0.167,0.438,0,0.604l-1.209,1.21c-0.167,0.167-0.438,0.167-0.605,0L10,11.814L5.954,15.86\r\n\tc-0.167,0.167-0.438,0.167-0.605,0l-1.209-1.21c-0.167-0.167-0.167-0.438,0-0.604L8.186,10L4.139,5.953\r\n\tc-0.167-0.167-0.167-0.438,0-0.604l1.209-1.209c0.167-0.167,0.438-0.167,0.605,0L10,8.186l4.046-4.046\r\n\tc0.167-0.167,0.438-0.167,0.605,0l1.209,1.209c0.167,0.167,0.167,0.438,0,0.604L11.814,10L15.86,14.046z\"/> </symbol>";
module.exports = sprite.add(image, "icon-close");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/close.svg
 ** module id = 162
 ** module chunks = 24
 **/